import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import validator from 'validator'

import { url, handleCommonEditActions, validationMessage } from '../../../common/helpers'
import * as formatters from '../../../common/formatters'
import { Form, InputField, SelectField, SubmitButton } from '../../../common/form'
import { createGetDriverSurchargeTypeByIDSelector, createGetCurrentDriverSurchargeTypeStatusSelector } from '../selectors'
import * as driverSurchargeTypesActionCreators from '../actionCreators'
import { LoadingOverlay } from '../../../common/loading_overlay'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'
import * as constants from '../constants'

class DriverSurchargeTypesEdit extends Component {
    defaultValues = {}

    validationRules = {
        name: value => validator.isEmpty(String(value)) && validationMessage('isEmpty'),
    }

    state = {
        values: this.defaultValues,
    }

    setValues = (values, callback) => {
        this.setState(
            {
                values,
            },
            callback
        )
    }

    handleChangeValues = values => {
        this.setValues(values)
    }

    handleSubmit = values => {
        this.setValues(values, () => {
            this.handleSave()
        })
    }

    handleSave = () => {
        this.props.actions.saveDriverSurchargeType(this.state.values)
    }

    componentDidMount() {
        this.props.match.params.driverSurchargeTypeID && this.props.actions.fetchDriverSurchargeType(this.props.match.params.driverSurchargeTypeID)
    }

    componentWillReceiveProps(nextProps) {
        handleCommonEditActions(this.props, nextProps, () => {
            this.props.redirect(url(this.props.match, 'driver-surcharge-types'))
        })

        if (JSON.stringify(nextProps.driverSurchargeType) !== JSON.stringify(this.props.driverSurchargeType) || (nextProps.driverSurchargeType && !this.state.values.id)) {
            this.setValues(nextProps.driverSurchargeType.toJS())
        }
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.driverSurchargeTypes.heading' }))

        const typesOptions = [{
            id: constants.DRIVER_SURCHARGE_TYPE_DAY,
            name: this.props.intl.formatMessage({ id: `driverSurchargeTypes.${constants.DRIVER_SURCHARGE_TYPE_DAY}` }),
        }, {
            id: constants.DRIVER_SURCHARGE_TYPE_MONTH,
            name: this.props.intl.formatMessage({ id: `driverSurchargeTypes.${constants.DRIVER_SURCHARGE_TYPE_MONTH}` }),
        },]

        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className={'page-inner '+(document.body.classList.contains('mobile-menu-open') ? 'sidebar-visible' : '')}>
                    <div id="main-wrapper">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4">
                                <div className="panel panel-white">
                                    <div className="panel-body panel-padding">
                                        <div className="panel-head">
                                            <h4>
                                                <FormattedMessage id="modules.driverSurchargeTypes.heading" /> -{' '}
                                                {this.props.driverSurchargeType ? (
                                                    <FormattedMessage id="fields.itemEdit" />
                                                ) : (
                                                    <FormattedMessage id="fields.itemCreate" />
                                                )}
                                            </h4>
                                        </div>
                                        <LoadingOverlay active={this.props.status.get('fetching')}>
                                            <PermissionsCheck hasAny={Object.values(PERMS)}>
                                                <Form
                                                    values={this.state.values}
                                                    validationRules={this.validationRules}
                                                    onChange={this.handleChangeValues}
                                                    onSubmit={this.handleSubmit}
                                                    isEdit={Boolean(this.props.driverSurchargeType)}
                                                >
                                                    <InputField id="name" label={this.props.intl.formatMessage({ id: 'fields.name' })} />

                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <InputField id="code" label={this.props.intl.formatMessage({ id: 'fields.code' })} />
                                                        </div>
                                                    </div>

                                                    <SelectField
                                                        id="type"
                                                        label={this.props.intl.formatMessage({ id: 'fields.driverSurchargeType' })}
                                                        values={typesOptions}
                                                        className="wp-50"
                                                    />

                                                    <div className="btns-form">
                                                        <Link to={url(this.props.match, 'driver-surcharge-types')} className="btn btn-addon btn-default">
                                                            <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                        </Link>
                                                        <SubmitButton
                                                            perms={Object.values(PERMS)}
                                                            isEdit={Boolean(this.props.driverSurchargeType)}
                                                            className="btn-addon pull-right"
                                                        />
                                                    </div>
                                                </Form>
                                            </PermissionsCheck>
                                        </LoadingOverlay>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        driverSurchargeType: createGetDriverSurchargeTypeByIDSelector(ownProps.match.params.driverSurchargeTypeID)(state),
        status: createGetCurrentDriverSurchargeTypeStatusSelector()(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...driverSurchargeTypesActionCreators,
                },
                dispatch
            ),
        },
        redirect: toURL => dispatch(push(toURL)),
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(DriverSurchargeTypesEdit)
)
